(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialisationKey = '__productCardDesktopDragGuard';

    if (window[initialisationKey]) return;

    window[initialisationKey] = true;

    const gallerySelector =
      'product-card card-gallery, product-card .card-gallery';

    const galleryImageSelector =
      'product-card card-gallery img, product-card .card-gallery img';

    const interactiveSelector =
      'button, input, select, textarea, summary, label, [role="button"], [contenteditable="true"]';

    const dragThreshold = 8;
    const clickSuppressionDuration = 400;

    let activeGesture = null;
    let blockedGallery = null;
    let blockClickUntil = 0;

    const clearActiveGesture = () => {
      activeGesture = null;
    };

    const clearBlockedClick = () => {
      blockedGallery = null;
      blockClickUntil = 0;
    };

    document.addEventListener(
      'pointerdown',
      (event) => {
        if (event.isPrimary === false) return;
        if (event.pointerType !== 'mouse') return;
        if (event.button !== 0) return;
        if (!(event.target instanceof Element)) return;
        if (event.target.closest(interactiveSelector)) return;

        const gallery = event.target.closest(gallerySelector);

        if (!gallery) return;

        activeGesture = {
          gallery,
          pointerId: event.pointerId,
          startX: event.clientX,
          startY: event.clientY
        };
      },
      {
        passive: true
      }
    );

    window.addEventListener(
      'pointerup',
      (event) => {
        if (
          !activeGesture ||
          activeGesture.pointerId !== event.pointerId
        ) {
          return;
        }

        const movementX = Math.abs(
          event.clientX - activeGesture.startX
        );

        const movementY = Math.abs(
          event.clientY - activeGesture.startY
        );

        if (
          movementX >= dragThreshold &&
          movementX > movementY
        ) {
          blockedGallery = activeGesture.gallery;
          blockClickUntil =
            performance.now() + clickSuppressionDuration;
        }

        clearActiveGesture();
      },
      {
        passive: true
      }
    );

    window.addEventListener(
      'pointercancel',
      clearActiveGesture,
      {
        passive: true
      }
    );

    window.addEventListener(
      'blur',
      clearActiveGesture
    );

    document.addEventListener(
      'click',
      (event) => {
        if (!blockedGallery) return;

        if (performance.now() > blockClickUntil) {
          clearBlockedClick();
          return;
        }

        if (!(event.target instanceof Element)) return;

        if (event.target.closest(interactiveSelector)) {
          return;
        }

        const clickedGallery =
          event.target.closest(gallerySelector);

        if (clickedGallery !== blockedGallery) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        clearBlockedClick();
      },
      true
    );

    document.addEventListener(
      'dragstart',
      (event) => {
        if (!(event.target instanceof Element)) return;

        const galleryImage =
          event.target.closest(galleryImageSelector);

        if (!galleryImage) return;

        event.preventDefault();
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
